import { useEffect, useState } from "react";
import { Reveal } from "../anim";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function useActiveHeading(ids) {
  const [active, setActive] = useState(ids[0]);
  useEffect(() => {
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean);
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-20% 0px -65% 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [ids]);
  return active;
}

export function GuideBody({ guide }) {
  const ids = guide.sections.map((s) => slugify(s.h));
  const active = useActiveHeading(ids);
  const quoteAfter = Math.min(2, guide.sections.length - 1);

  return (
    <section className="surface-day py-20 lg:py-28" data-testid="guide-body">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 grid gap-12 lg:grid-cols-12 lg:gap-16">
        <aside className="hidden lg:block lg:col-span-3">
          <nav className="lg-toc" aria-label="In this orientation" data-testid="guide-toc">
            <p className="lg-eb text-champagne mb-4">In this orientation</p>
            {guide.sections.map((s, i) => (
              <a key={ids[i]} href={`#${ids[i]}`} className={active === ids[i] ? "is-active" : ""}>{s.h}</a>
            ))}
          </nav>
        </aside>
        <div className="lg-body lg:col-span-8 max-w-3xl">
          {guide.sections.map((s, i) => (
            <div key={ids[i]}>
              <Reveal as="section" id={ids[i]} data-testid={`guide-section-${i + 1}`}>
                <h2>{s.h}</h2>
                {s.p.map((para, j) => <p key={j}>{para}</p>)}
              </Reveal>
              {i === quoteAfter && (
                <Reveal as="blockquote" className="lg-quote" data-testid="guide-quote">{guide.quote}</Reveal>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
